import './score-label.less';

import { permissionsServiceModule } from '../../services/permissions-service/permissions';

const RISK_LEVEL_TOOLTIPS = {
  low: `Similar solutions have been found, but there is a low risk of cheating.`,
  medium: `Similar solutions have been found. It is recommended to look further into the solution.`,
  high: `Very similar or exact solutions have been found that likely indicate this code was not original.`,
};

/**
 * @docType shared
 * @category directive
 * @name Score-Label
 * @description
 * A directive that displays a candidates score on a test
 * @returns Directive Definition Object {object}
 */
export const scoreLabelComponentModule = angular
  .module('Q.components.score-label', [permissionsServiceModule])
  .directive('scoreLabel', function (permissionsService) {
    return {
      restrict: 'E',
      scope: {
        value: '<',
        unsubmitted: '<',
        lowerIsBetter: '<',
        similarity: '<',
        excludeFromAccuracy: '<',
        onSimilarityClick: '&',
      },
      template: `\
<span class="label score {{ scoreClass() }}" ng-bind="score()"></span>\
<span class="label score-risk score-risk-{{riskLevel()}}" ng-if="riskLevel()" tooltip="{{riskTooltip()}}" ng-click="onSimilarityClick()"></span>`,
      link: function (scope) {
        function hasScore() {
          return (
            scope.value !== null &&
            scope.value !== undefined &&
            !isNaN(parseFloat(scope.value))
          );
        }

        scope.score = () => {
          return hasScore() ? Math.floor(scope.value || 0) + '%' : '';
        };
        scope.scoreClass = () => {
          let className = 'score-';
          if (scope.excludeFromAccuracy) {
            className += 'excluded';
          } else if (!hasScore()) {
            className += 'none';
          } else if (scope.unsubmitted) {
            className += 'unsubmitted';
          } else {
            className += Math.min(
              100,
              Math.floor((scope.value || 0) / 10) * 10,
            );
          }
          if (scope.lowerIsBetter) {
            className += ' lower-is-better';
          }
          if (scope.riskLevel()) {
            className += ' score-has-risk';
          }
          return className;
        };

        scope.riskLevel = () => {
          let similarity = scope.similarity;
          let riskLevel = similarity && similarity.riskLevel;
          return (
            permissionsService.feature('codeSimilarity') &&
            riskLevel !== 'none' &&
            riskLevel
          );
        };

        scope.riskTooltip = () => RISK_LEVEL_TOOLTIPS[scope.riskLevel()];
      },
    };
  });
